// Dependencies
import React from 'react';
import radium from 'radium';
import CheckoutButtons from "./CheckoutButtons";
import {ThemeContext} from "../../components/theme/Theme.jsx";
import history from "../../lib/history";
import {connect} from "react-redux";

function CheckoutError(props) {
	const context = React.useContext(ThemeContext)
	const style = {
		container: {
			margin: 'auto',
		},
		error: {
			fontWeight: '600',
			textAlign: 'center',
		},
		buttonContainer: {
			marginTop: '3em',
		},
	};

	function getEventPathPartIfPresent(event) {
		if (!event) {
			return '';
		}
		const salePrefix = event.seatingplanUuid ? 'sp/' : 'fs/';
		const url = salePrefix + event.uuid;
		return `${url}/`;
	}

	return (
		<div style={style.container}>
			<div style={style.error}
				dangerouslySetInnerHTML={{
					__html: context.themeManager
						.getThemeTextOrHardcodedDefault('checkoutErrorPageText'),
				}}/>

			<CheckoutButtons
				btnResetLabel={context.themeManager.getThemeTextOrHardcodedDefault('backToSCBtnLabel')}
				onResetClick={()=> history.push(`${getEventPathPartIfPresent(props.event)}shoppingcart`)}
				hideNextButton={true}
				hideBackButton={true}
				btnResetStyle={'highlight'}
			/>
		</div>
	);
}

const mapStateToProps = (state) => {
	const event = state.event.elements[state.event.selected] || null;
	return {
		event,
	}
};
const RadiumCheckoutError = radium(CheckoutError);

export default connect(mapStateToProps)(RadiumCheckoutError);
